module.exports = __webpack_public_path__ + "img/GIS_Women_Rights.6b981660.svg";